import { motion } from "motion/react";
import { Link } from "react-router-dom";

export default function PersianasServicesSection() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: text */}
          <motion.div
            className="w-full lg:w-1/2"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-6">
              Servicios de persianas en Málaga
            </h2>
            <div className="w-10 h-1 bg-primary rounded-full mb-6"></div>
            <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed">
              En Persianas Toldos Málaga llevamos desde 2015 reparando todo tipo de averías en persianas: persianas que no suben o bajan, motores estropeados o ruidosos, cintas rotas o desgastadas, lamas dañadas y cajones desencajados. Trabajamos con todas las marcas del mercado, tanto Somfy como Cherubini o Becker, y en cualquier tipo de persiana: manuales, eléctricas, motorizadas, de aluminio o PVC. Nuestro técnico propio se desplaza en menos de 24 horas a tu domicilio en Málaga capital, Marbella, Fuengirola, Torremolinos, Benalmádena, Mijas o Estepona, con presupuesto gratuito y sin compromiso. Si tu persiana eléctrica ha dejado de funcionar o necesitas motorizar una persiana manual antigua operada con cinta, llámanos al{" "}
              <a href="tel:+34951120770" className="text-primary hover:text-primary-dark font-semibold underline underline-offset-4 transition-colors">
                951 12 07 70
              </a>{" "}
              o escríbenos por WhatsApp al{" "}
              <a href="https://wa.me/34627213347?text=Hola%2C%20me%20interesa%20info" target="_blank" rel="noopener noreferrer" className="text-whatsapp hover:text-[#128C7E] font-semibold underline underline-offset-4 transition-colors">
                627 21 33 47
              </a>.
            </p>
          </motion.div>

          {/* Right: image */}
          <motion.div
            className="w-full lg:w-1/2 relative"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
          >
            <div className="relative rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20professional%20technician%20repairing%20a%20white%20aluminum%20roller%20shutter%20blind%20on%20a%20Mediterranean%20house%20window%20using%20tools%2C%20bright%20sunny%20day%2C%20clean%20professional%20service%20photography%2C%20white%20facade%20with%20terracotta%20roof%20tiles%2C%20warm%20natural%20light%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=persianas-services-home&orientation=landscape&format=webp"
                alt="Técnico profesional reparando persianas en Málaga y Costa del Sol"
                className="w-full h-auto object-cover aspect-[4/3]"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}